export default function Selector(state, property) {
  const selectors = {
    basket: (s) => s.basket?.list || [],
  };
  return selectors[property](state);
}
